// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3tGRg","loupeMobile":"Header_loupeMobile__3dyt-","omniSearch":"Header_omniSearch__2N_5t"};